"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//@ts-nocheck
/**
 * Custom on click events via data attribute
 *
 * @namespace
 * @memberOf txGs1Base
 * @public
 */
const _main_1 = require("./_main");
_main_1.txGs1Base.onClickEvents = {
    initialize: function () {
        $('*[data-onclick-active]').each(function (index, item) {
            let $item = $(item);
            $(document).on('click', '.pseudo-link', function (event) {
                window.location.href = $item.attr('data-href');
                return false;
            });
        });
    }
};
exports.default = {};
